// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__25aj2","ranges":"BmiRanges_ranges__3nuPd"};